import { Component, Input } from '@angular/core';
import { IPageContentDto } from 'src/app/core/dtos/interfaces/i-page-content-dto';
import { ContentStatus } from '../../enums/content-status';
import { ContentTypeRouterPaths } from '../../enums/content-type-router-paths';

@Component({
  selector: 'app-content-status-message',
  templateUrl: './content-status-message.component.html',
  styleUrls: ['./content-status-message.component.scss'],
})
export class ContentStatusMessageComponent {
  @Input() content!: Partial<IPageContentDto>;
  @Input() contentType!: string;

  CONTENT_STATUS = ContentStatus;
  CONTENT_TYPE_ROUTER_PATH = ContentTypeRouterPaths;
}
